import request from '@/api/request'

export default {
    listCustomBackgrounds() {
        return request({
            url: '/customBackground/list',
            method: 'get'
        })
    },
    addCustomBackground(data) {
        return request({
            url: '/customBackground/add',
            method: 'post',
            data
        })
    },
    updateCustomBackground(data) {
        return request({
            url: '/customBackground/update',
            method: 'post',
            data
        })
    },
    deleteCustomBackground(id) {
        return request({
            url: '/customBackground/delete',
            method: 'post',
            params: { id }
        })
    },
    uploadCustomBackground(file, onProgress) {
        const formData = new FormData()
        formData.append('file', file)
        return request({
            url: '/customBackground/upload',
            method: 'post',
            data: formData,
            timeout: 300000,
            onUploadProgress: (progressEvent) => {
                if (onProgress && progressEvent.total > 0) {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    onProgress(percent, progressEvent)
                }
            }
        })
    }
}
